import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=a549a702&"
import script from "./RoleCreate.vue?vue&type=script&lang=ts&"
export * from "./RoleCreate.vue?vue&type=script&lang=ts&"
import style0 from "./RoleCreate.vue?vue&type=style&index=0&id=a549a702&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports